import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
export const EditStockTransferItem = (props) => {
    return (
        <ModalBasic
            id="cityMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Bank details</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3 items-center'>
                    <div className='input-grp col-span-3'>
                        <label>WO Quantity</label>
                        <TextInput type='text'
                            id='woQuantity' name='woQuantity'
                            value={props.itemObject.woQuantity}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'woQuantity')}
                            className={props.validState?.error?.woQuantity !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>

                    <div className='input-grp col-span-2'>
                        <label>Quantity</label>
                        <TextInput type='text'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'quantity')}
                            max={props.itemObject.woQuantity > 0 ? props.itemObject.woQuantity : 0}
                            min={0}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Avl Stock</label>
                        <TextInput type='text'
                            id='avlStock' name='avlStock'
                            value={props.itemObject.avlStock}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'avlStock')}
                        //className={`${props.validState?.error?.avlStock !== undefined ? "error" : ""}`}
                        //checked={props.itemObject.isCancel}
                        />
                    </div>
                    {/* <div className='input-grp col-span-2'>
                        <button className="save-btn btns mt-auto mb-[2px]" >Add</button>
                    </div> */}
                </div>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3 items-center'>
                    <div className='input-grp col-span-3'>
                        <label>Rate</label>
                        <TextInput type='text'
                            id='rate' name='rate'
                            value={props.itemObject.rate}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'rate')}
                            className={props.validState?.error?.rate !== undefined ? "error" : ""}
                        />
                    </div>

                    <div className='input-grp col-span-2'>
                        <label>Amount</label>
                        <TextInput type='text'
                            id='amount' name='amount'
                            value={props.itemObject.amount}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'amount')}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Display Serial No</label>
                        <TextInput type='text'
                            id='displaySerialNo' name='displaySerialNo'
                            value={props.itemObject.displaySerialNo}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'displaySerialNo')}
                        //className={`w-[15px] h-[15px] ${props.validState?.error?.displaySerialNo !== undefined ? "error" : ""}`}
                        //checked={props.itemObject.isCancel}
                        />
                    </div>
                    {/* <div className='input-grp col-span-2'>
                        <button className="save-btn btns mt-auto mb-[2px]" >Add</button>
                    </div> */}
                </div>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3 items-center'>
                    <div className='input-grp col-span-3'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChangeForChequeBookItem(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    {props.itemObject.keyId > 0 ?
                        <button className="update-btn btns" onClick={() => props.insertItem()}>Add</button>
                        :
                        null
                    }
                </div>
            </div>

        </ModalBasic>
    )
}